unit BaseType;
{

/* Not needed. */

/* Initial. */

}
interface

type
  TBaseType = class(TObject)
  end;

implementation

end.
